import { SvgIconDefaultProps } from '@libs/components';
import { IconsContainer, CountContainer } from './styles';

type IconsData = {
  icon: React.FC<SvgIconDefaultProps>;
  id: string;
};

type AssetIconsListProps = {
  icons: IconsData[];
  count: number;
};

const AssetIconsList: React.FC<AssetIconsListProps> = ({ icons, count }) => {
  return (
    <IconsContainer>
      {icons.map((item, index) => {
        return (
          <item.icon
            key={item.id}
            className={index > 0 ? 'overlapping-item' : ''}
          />
        );
      })}
      <CountContainer className="overlapping-item">
        {`${count}+`}
      </CountContainer>
    </IconsContainer>
  );
};

export default AssetIconsList;
